export const DELIVERY_ACTIONS_MODAL = 'deliveryActions';

export const FULL_COLUMNS = 12;
export const TWO_COLUMNS = 6;
export const FOUR_COLUMNS = 4;
export const EIGHT_COLUMNS = 8;
